import { render, staticRenderFns } from "./salesAssemblyPricingEditor.vue?vue&type=template&id=c4383358&"
import script from "./salesAssemblyPricingEditor.vue?vue&type=script&lang=js&"
export * from "./salesAssemblyPricingEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports